import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core'
import { FormGroup } from '@angular/forms'
@Component({
  selector: 'dmmp-form-input-inside-validations',
  templateUrl: './input-inside-validations.component.html',
})
export class InputInsideValidationsComponent implements OnInit, OnChanges {
  @Input() field
  @Input() fieldData
  @Input() identifier
  @Input() spinnerInput
  @Input() group: FormGroup
  @Output() changeValueInput: EventEmitter<any> = new EventEmitter<any>()
  showLabelPrefix: boolean
  constructor() {
  }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.fieldData) {
      this.group.get(this.field?.name).setValue(this.fieldData)
    }
  }

  filterInput(event: any) {
    return event.keyCode !== 69
  }
}
